import { render } from "./publicLayout.vue?vue&type=template&id=19924c7d"
import script from "./publicLayout.vue?vue&type=script&lang=js"
export * from "./publicLayout.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__